module.exports = __webpack_public_path__ + "img/ipa.1faf9d55.png";